import { ChipProps } from '@mui/material';
import { useEffect, useState } from 'react';
import { StyledChip } from './Chip.styles';
import { ChipPropTypes, StyledChipPropTypes } from './Chip.types';
// import chipDeleteCross from '';

export function Chip(props: ChipPropTypes): JSX.Element {
  const [innerProps, setInnerProps] = useState(props as StyledChipPropTypes);

  useEffect(() => {
    if (props?.variant === 'highlighted') {
      setInnerProps({
        ...props,
        variant: 'filled',
        color: 'default',
        textColor: props.color,
      } as StyledChipPropTypes);
    }
  }, [props]);

  return <StyledChip {...(innerProps as ChipProps)} />;
}
